import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
} from 'firebase/firestore';

const db = getFirestore();

// Função para validar o CRM
export async function validarCrm(crm) {
  const usersRef = collection(db, 'users');
  const q = query(usersRef, where('crm', '==', crm));
  const querySnapshot = await getDocs(q);

  if (!querySnapshot.empty) {
    const userDoc = querySnapshot.docs[0];
    return userDoc.id; // Retorna o ID do usuário correspondente ao CRM
  } else {
    throw new Error('Código não encontrado.');
  }
}

// Valida a receita pelo token
export async function validarReceita(token) {
  try {
    const receitaRef = doc(db, 'receitasDigitalGeradas', token);
    const receitaDoc = await getDoc(receitaRef);

    if (receitaDoc.exists()) {
      const receitaData = receitaDoc.data();
      if (receitaData.dataEmissao) {
        // Converte a data do formato ISO para dd/mm/yyyy hh:mm:ss
        const dataEmissaoFormatada = new Date(
          receitaData.dataEmissao
        ).toLocaleString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
        receitaData.dataEmissao = dataEmissaoFormatada;
      }
      return receitaData;
    } else {
      throw new Error('Receita não encontrada');
    }
  } catch (error) {
    console.error('Erro na validação da receita:', error);
    throw error;
  }
}
